import React from "react";

const faqs = [
  {
    question: "What grades do you teach?",
    answer:
      "We teach students from Grade 6 to Grade 12, and help them prepare for school exams and competitive tests like Olympiads, SAT, IIT-JEE, and NEET.",
  },
  {
    question: "Are classes online or offline?",
    answer:
      "Both! We offer offline classes in Riyadh and online classes so your child can learn from home or in person.",
  },
  {
    question: "What makes Achievers iQ special?",
    answer:
      "We follow a Trio Model for Success:\n✅ Expert Teachers\n✅ Personal Mentorship\n✅ 1% Daily Improvement\nWe also use smart AI tools to help students improve every day.",
  },
  {
    question: "Will my child get personal attention in online classes?",
    answer:
      "Yes! We keep our batches small, offer 1-on-1 mentoring, and track each child’s progress using smart tools.",
  },
  {
    question: "Do you follow the CBSE curriculum?",
    answer:
      "Yes, we follow CBSE and NCERT, and also help students prepare for entrance exams like JEE, NEET, and Olympiads.",
  },
  {
    question: "Can we try a class before joining?",
    answer:
      "Of course! You can book a free demo class to see how we teach.",
  },
  {
    question: "How do you check if my child is improving?",
    answer:
      "We do weekly tests, track performance with AI tools, and send regular updates to parents.",
  },
  {
    question: "Who are the teachers?",
    answer:
      "Our teachers are experienced and expert educators who’ve been teaching JEE, NEET, SAT, and board students for years.",
  },
  {
    question: "Is there help outside class hours?",
    answer:
      "Yes! Students can ask doubts, watch recorded lessons, and talk to mentors even after class.",
  },
  {
    question: "Is your Riyadh center safe?",
    answer:
      "Yes, our center is safe, secure, and designed for a focused learning experience.",
  },
  {
    question: "Do you provide transport",
    answer:
      "Yes, we assist with your transport.",
  },
];

const HelpUs = () => {
  return (
    <div className="container my-5">
      <h1 className="mb-4 text-center">Frequently Asked Questions</h1>
      <div className="accordion mb-5" id="faqAccordion">
        {faqs.map((faq, index) => (
          <div className="accordion-item" key={index}>
            <h3 className="accordion-header" id={`heading${index}`}>
              <button
                className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded={index === 0 ? "true" : "false"}
                aria-controls={`collapse${index}`}
              >
                <b>{faq.question}</b>
              </button>
            </h3>
            <div
              id={`collapse${index}`}
              className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
              aria-labelledby={`heading${index}`}
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body" style={{ whiteSpace: "pre-line" }}>
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* <div className="card p-4 mb-5 shadow-sm">
        <h4>Contact Us</h4>
        <form>
          <div className="row text-center mb-3 justify-content-center">
            <div className="col-md-6">
              <label className="form-label">Name</label>
              <input type="text" className="form-control" placeholder="Your Name" required />
            </div>
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" placeholder="Your Email" required />
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Message</label>
            <textarea className="form-control" rows="4" placeholder="Your Message..." required></textarea>
          </div>
          <button type="submit" className="btn btn-primary">Send Message</button>
        </form>
      </div> */}
    </div>
  );
};

export default HelpUs;
